import { render, staticRenderFns } from "./SmsEditView.vue?vue&type=template&id=8832eb46&scoped=true&"
import script from "./SmsEditView.vue?vue&type=script&lang=js&"
export * from "./SmsEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8832eb46",
  null
  
)

export default component.exports